const initialState = {
  hiddenOutcomes: [],
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case "SHOW_OUTCOME":
      return {
        ...state,
        hiddenOutcomes: [
          ...state.hiddenOutcomes.filter((outcome) => outcome != payload),
        ],
      };
    case "HIDE_OUTCOME":
      return {
        ...state,
        hiddenOutcomes: [...state.hiddenOutcomes, payload],
      };
    default:
      return state;
  }
}
